import React, { useContext } from 'react';
import NoteAddIcon from '@material-ui/icons/NoteAdd';
import CloseIcon from '@material-ui/icons/Close';
import makeStyles from '@material-ui/core/styles/makeStyles';
import {
  DetailContext,
  DetailMode,
  DetailToolbarButtonType,
  DetailActionbarButton,
} from '@eas/common-web';
import { useCreateNoteDialog } from '../../components/evidence/noted-evidence/dialog-actions/create-note-hook';
import { EntityType } from '../../enums/entity-type';
import { useRejectDialog } from './dialog-actions/reject-hook';
import { useApproveDialog } from './dialog-actions/approve-hook';
import DoneIcon from '@material-ui/icons/Done';
import { useCancelDialog } from './dialog-actions/cancel-hook';

export const useStyles = makeStyles(() => ({
  toolbarIndentLeft: {
    marginLeft: 10,
  },
}));

export function OvzFacilityRequestsActionbar() {
  const { mode } = useContext(DetailContext);

  const {
    handleCreateNote,
    showCreateButton: showCreateNote,
  } = useCreateNoteDialog({
    entityType: EntityType.OVZ_FACILITY_REQUEST,
  });
  const { handleReject, showRejectButton } = useRejectDialog();
  const { handleApprove, showApproveButton } = useApproveDialog();
  const { handleCancel, showCancelButton } = useCancelDialog();

  return (
    <>
      {mode === DetailMode.VIEW && (
        <div style={{ flexWrap: 'wrap' }}>
          {showApproveButton && (
            <DetailActionbarButton
              startIcon={<DoneIcon fontSize="small" />}
              label="Přijmout"
              onClick={handleApprove}
              type={DetailToolbarButtonType.PRIMARY}
            />
          )}
          {showRejectButton && (
            <DetailActionbarButton
              startIcon={<CloseIcon fontSize="small" />}
              label="Odmítnout"
              onClick={handleReject}
              type={DetailToolbarButtonType.SECONDARY}
            />
          )}
          {showCancelButton && (
            <DetailActionbarButton
              startIcon={<CloseIcon fontSize="small" />}
              label="Zrušit"
              onClick={handleCancel}
              type={DetailToolbarButtonType.SECONDARY}
            />
          )}
          {showCreateNote && (
            <DetailActionbarButton
              startIcon={<NoteAddIcon fontSize="small" />}
              label="Přidat poznámku"
              onClick={handleCreateNote}
              type={DetailToolbarButtonType.PRIMARY}
            />
          )}
        </div>
      )}
    </>
  );
}
